import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Observable } from 'rxjs';
import {
  HttpClient,
} from "@angular/common/http";
import { environment } from '../../../environments/environment';

import * as ios from 'socket.io-client'; //Socket(n)
import { isPlatformBrowser } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  //Socket(n)
  private url = environment.socket_base_url;//'http://localhost:3000';
  is_ssr: any;
  private socket;
  //Socket(n)

  constructor(private Http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    this.is_ssr = environment.is_ssr;
    if (this.is_ssr) {
      if (isPlatformBrowser(this.platformId)) {
        const io = require('socket.io-client');
        this.socket = io(environment.socket_base_url);//Socket(n)
      }
    } else {
      this.socket = ios(environment.socket_base_url);//Socket(n)
    }
  }

  //Socket Message(n)
  public sendMessageSocket(req) {
    this.socket.emit('socketMessageApi', req);
  }
  //Socket Message(n)

  //Socket Typing Message(n)
  public TypingMessageSocket(req) {
    this.socket.emit('sockeTypingtMessageApi', req);
  }

  public getTypingMessageSocket = () => {
    return Observable.create((observer) => {
      this.socket.on('sockeTypingtMessageApi', (res) => {
        observer.next(res);
      });
    });
  }
  //Socket Typing Message(n)

  //Socket Message(n)
  public sendMessageSocket2(req) {
    this.socket.emit('socketMessageApi', req);
  }
  //Socket Message(n)

  //Socket Typing Message(n)
  public TypingMessageSocket2(req) {
    this.socket.emit('sockeTypingtMessageApi', req);
  }

  public getTypingMessageSocket2(): Observable<any> {
    if (this.is_ssr) {
      return new Observable(observer => {
        if (this.socket) {
          this.socket.on('sockeTypingtMessageApi', res => {
            observer.next(res);
          });
        }
      });
    } else {
      return Observable.create((observer) => {
        this.socket.on('sockeTypingtMessageApi', (res) => {
          observer.next(res);
        });
      });
    }
  }
  //Socket Typing Message(n)

  getLoginUserInfoForChat() {
    return this.Http.get(`${environment.base_url}/getLoginUserInfoForChat`);
  }

  getConnactUserListForChat(data) {
    return this.Http.post(`${environment.base_url}/getConnactUserListForChat`, data);
  }

  getConnectedUsersListPostTimeline(data) {
    return this.Http.post(`${environment.base_url}/getConnectedUsersListPostTimeline`, data);
  }

  getChatUserDetails(data) {
    return this.Http.post(`${environment.base_url}/getChatUserDetails`, data);
  }

  sendMessageForChat(data) {
    return this.Http.post(`${environment.base_url}/sendMessageForChat`, data);
  }

  sendGifStickerForChat(data) {
    return this.Http.post(`${environment.base_url}/sendGifStickerForChat`, data);
  }

  sendFilesForChat(data) {
    return this.Http.post(`${environment.base_url}/sendFilesForChat`, data);
  }

  deleteChatMessages(data) {
    return this.Http.post(`${environment.base_url}/deleteChatMessages`, data);
  }

  deleteMessage(data) {
    return this.Http.post(`${environment.base_url}/deleteMessage`, data);
  }

  sendMessageForChatLiveMatch(data) {
    return this.Http.post(`${environment.base_url}/sendMessageForChatLiveMatch`, data);
  }

  getChatUserDetailsLiveMatch(data) {
    return this.Http.post(`${environment.base_url}/getChatUserDetailsLiveMatch`, data);
  }

  deleteMessageLiveMatch(data) {
    return this.Http.post(`${environment.base_url}/deleteMessageLiveMatch`, data);
  }

  checkMatchChatModal(data) {
    return this.Http.post(`${environment.base_url}/checkMatchChatModal`, data);
  }

  leaguesGifStickerImages(data) {
    return this.Http.post(`${environment.base_url}/leaguesGifStickerImages`, data);
  }

  sendGifStickerUserChatLiveMatch(data) {
    return this.Http.post(`${environment.base_url}/sendGifStickerUserChatLiveMatch`, data);
  }

  igtAssistant(data) {
    return this.Http.post(`${environment.social_media_url}/chatGPT`, data);
  }
}